@if(datas?.elements) {
    <div class="wrp">
        <app-contenteditor [datas]="datas"></app-contenteditor>
    </div>
}